import type { InjectionKey } from "vue";
import type { RetailInstanceTypeService } from "@/services/RetailInstanceTypeService";
/* eslint symbol-description: 0 */
export const retailInstanceTypeSymbol: InjectionKey<RetailInstanceTypeService> = Symbol() as InjectionKey<RetailInstanceTypeService>;
